import config from '../../config/config'
import axios from 'axios'
import { getToken } from '../../common'; 

export const sellerUpdateRightsAPI = async (params,sellerId) => {

    return await axios({
        method  : 'patch',
        url     : `${config.api.base_url}dashboard/sellers/${sellerId}/permissions`,
        data    : params,
        headers : {
            "Content-type": "application/json; charset=UTF-8",
            "Authorization": getToken(),
        }
    })
}

export default sellerUpdateRightsAPI